module.exports = __webpack_public_path__ + "21784c283937a6d5c4abdf89ce585971.woff2";